import Body from "./components/Body";
import "./styles/App.css";

function App() {
  return (
    <div className="App">
      <header>Create-A-Resume</header>
      <Body className = "body" />
      <footer>Created By Seulchan Han</footer>
    </div>
  );
}

export default App;
